/* tslint:disable */
import * as React from 'react';
import {Field, FieldArray, formValueSelector, reduxForm, InjectedFormProps, submit} from 'redux-form';
import {flow, map, forEach, size, difference, isEmpty, find, get} from 'lodash';
import {II18nMessages} from '../../../../services/branding/models';
import {Button, Col, ControlLabel, Form, FormGroup, Row, Modal} from 'react-bootstrap';
import FieldFormControl from '../../../../components/FieldFormControl';
import RegionSelect from './components/RegionSelect/RegionSelect';
import RegionSelected from './components/RegionSelect/RegionSelected';
import CruiseQuestion from './components/CruiseQuestion/CruiseQuestion';
import {connect} from 'react-redux';
import AlternativeDatePicker from '../../../../components/AlternativeDatePicker/index';
import {
  IChannel, IDestination, IProduct, IOccupation, IIndustry,
  IPolicyApplication, ITraveller,
} from '../../../../data/api/models';
import {
  isFutureDate, isRequired, isValidDate, annualLimit, singleLimit, singleMaxTripDuration,
} from '../../../../util/validators';
import * as moment from 'moment';
import {showDestinations, showDestinationDuration, isAnnual} from '../../../../data/api/api';
import {actions as quoteActions, getInitValues} from '../../../../services/quote/reducer';
import {IAuthState} from '../../../../services/auth/models';
import {bindActionCreators} from 'redux';
import {IQuoteActions} from '../../../../services/quote/models';
import Travellers from './components/Travellers';
import FaCheck from 'react-icons/fa/check';
import FaChevronRight from 'react-icons/fa/chevron-right';
import VoucherCode from '../../components/VoucherCode';
import MarketingOptions from '../../components/MarketingOptions';
import {IStore} from '../../../../redux/IStore';
import GroupType from './components/GroupType/GroupType';
import GroupTypeSelected from './components/GroupType/GroupTypeSelected';
import MaxTripDuration from './components/MaxTripDuration/MaxTripDuration';
import ActivitiesSelect from './components/ActivitiesSelect/ActivitiesSelect';
import CovidStatement from './components/CovidStatement';
import SelectControl from '../../../../components/SelectControl';

interface ITripDetailsFormProps extends InjectedFormProps {
  destinations: IDestination[];
  occupations: IOccupation[];
  industries: IIndustry[];
  auth: IAuthState;
  i18n: II18nMessages;
  travellers: ITraveller[];
  groupType: string;
  cruiseCover: boolean;
  tripType: string;
  startDate: string;
  region: string;
  maxTripDuration: string;
  schemeId: string;
  endDate: string;
  dispatch: any;
  product: IProduct;
  destinationsValue: string[];
  occupationValue: string[];
  industryValue: string[];
  channel: IChannel;
  quote: IPolicyApplication;

  renderDefinition(name: string): any;

  actions: {
    quote: IQuoteActions;
    submit(name: string);
  };
}

interface ITripDetailsStates {
  showBlockerModal: boolean;
  modalMessage: string;
  region: string;
  activities: string[];
  activitiesValid: boolean;
}

class TripDetailsForm extends React.Component<ITripDetailsFormProps, ITripDetailsStates> {
  public state = {
    showBlockerModal: false,
    modalMessage: '',
    region: '',
    activities: [],
    activitiesValid: true,
  };

  public componentWillMount() {
    const {product, change, initialValues, dispatch, channel, auth} = this.props;

    const data = getInitValues(product, null, null);

    forEach(data, (value, key) => {
      if (initialValues[key] === null) {
        change(key, value);
      }
    });

    const dateFromApi = (date) => {
      if (!date) {
        return '';
      }

      const parsedDate = moment(date).format('DD/MM/YYYY');

      return parsedDate !== 'Invalid Date' ? parsedDate : '';
    };

    dispatch(change('salesChannel', channel.key));
    dispatch(change('quotationTypes', 'Direct'));
    // dispatch(change('emailSend', false));

    if (auth.isAuthenticated) {
      dispatch(change('travellers[0].title', auth.customer.title));
      dispatch(change('travellers[0].dob', dateFromApi(auth.customer.dob)));
      dispatch(change('travellers[0].firstName', auth.customer.firstName));
      dispatch(change('travellers[0].lastName', auth.customer.lastName));
      dispatch(change('travellers[0].email', auth.customer.email));
      dispatch(change('travellers[0].phone', auth.customer.phone1));
      dispatch(change('travellers[0].address.postcode', auth.customer.address.postcode));
      dispatch(change('travellers[0].address.line1', auth.customer.address.line1));
      dispatch(change('travellers[0].address.line2', auth.customer.address.line2));
      dispatch(change('travellers[0].address.town', auth.customer.address.town));
      dispatch(change('travellers[0].address.country', auth.customer.address.country));
    }
  }

  public componentDidUpdate() {
    const {tripType, dispatch, change, product} = this.props;
    let regionTripType = tripType;

    if (product.productCode === 'LSB') {
      regionTripType = 'longstay';
    }

    if (regionTripType === 'single') {
      // dispatch(change('region', ''));
      dispatch(change('maxTripDuration', ''));
    }

    if (regionTripType === 'annual') {
      dispatch(change('destinations', ''));
      dispatch(change('endDate', ''));
      if (size(product.metadata.annual_trip_durations) === 1) {
        dispatch(change('maxTripDuration', Object.keys(product.metadata.annual_trip_durations)[0]));
      }
    }

    if (regionTripType === 'longstay') {
      dispatch(change('destinations', ''));
      dispatch(change('maxTripDuration', ''));
    }
  }

  private getAge = (dob) => {

    if (isEmpty(dob)) {
      return null;
    }

    const convertedDate = dob.split(/\//).reverse().join('/');
    return moment().diff(convertedDate, 'years');
  }

  public componentWillReceiveProps(nextProps) {
    const {tripType, dispatch, change, actions, schemeId} = this.props;

    if (schemeId && tripType !== nextProps.tripType) {
      dispatch(change('schemeId', ''));
      actions.quote.calculate(null, true);
    }
  }

  public renderAboutUs = () => {
    const {channel} = this.props;
    const TERMS_OF_BUSINESS = 'Terms of Business';
    const aiosDocument = find(channel.productDocuments, (document) => {
      return document.shortName === TERMS_OF_BUSINESS;
    });
    const aboutUsUrl = aiosDocument ? aiosDocument.filePath : '';

    let privacyUrl =  '/privacy';
    if (['adv-b2c'].includes(channel.key)) {
      privacyUrl = 'https://www.pjhayman.com/documents/important_documents/PJH_Privacy_policy.pdf';
    }
    if (['cps-b2c'].includes(channel.key)) {
      privacyUrl = 'https://www.coachpluscover.co.uk/documents/Socprivacypolicy.pdf';
    }
    if (['eurp-b2c'].includes(channel.key)) {
      privacyUrl = 'https://www.europluscover.co.uk/documents/Socprivacypolicy.pdf';
    }

    return (
      <div className="margin-top margin-bottom">
        For more information about our service to you and how we will use your information,
        please read our <a href={aboutUsUrl} target="_blank"><strong>Terms of Business</strong> </a>
        and our <a href={privacyUrl} target="_blank"><strong>Privacy Policy</strong></a>.
      </div>
    );
  }

  private checkForErrorBeforeSubmit = () => {
    const {tripType, startDate, endDate, travellers, actions, product, maxTripDuration, channel} = this.props;
    const start = moment(startDate, 'DD/MM/YYYY');
    const end = moment(endDate, 'DD/MM/YYYY');
    const tripDuration = tripType === 'single' ? end.diff(start, 'days') : maxTripDuration;

    const validationRules = {
      FST: {
        single: [
          {maxTrip: 90, maxAge: 79},
        ],
        annual: [],
      },
      DIA: {
        single: [
          {maxTrip: 90, maxAge: 79},
        ],
        annual: [
          {productCode: 'DIA', maxAge: 79},
        ],
      },
    };

    const validationMessages = {
      DIA: 'Sorry, Diabetes is unable to provide a quote due to your age.',
    };

    let message;
    const rules = validationRules[product.productCode] && validationRules[product.productCode][tripType] || [];
    const valid = travellers.reduce((carry, traveller) => {
      const travellerAge = this.getAge(traveller.dob);
      return carry && rules.reduce((carry, rule) => {
        if (rule.maxAge) {
          if (travellerAge > rule.maxAge) {
            carry =  rule.maxTrip ? carry && tripDuration <= rule.maxTrip :  carry && travellerAge <= rule.maxAge;
          }
          return carry;
        }
      }, true);
    }, true);
    message = validationMessages[product.productCode] || 'Sorry, ' + channel.name +
      ' is unable to provide a quote online due to your planned trip duration.';

    if (!valid) {
      this.setState({
        showBlockerModal: true,
        modalMessage: message,
      });
    } else {
      actions.submit('quote');
    }
  }

  private closeBlockerModal = () => {
    this.setState({
      showBlockerModal: false,
    });
  }

  private renderBlockerModal = () => {
    const {channel} = this.props;
    const {modalMessage} = this.state;

    return (
      <Modal show={this.state.showBlockerModal} onHide={this.closeBlockerModal}>
        <Modal.Header closeButton={true}>
          <Modal.Title>Attention required</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ul>
            <li>
              <p>
                {modalMessage}
              </p>
              <p>
                Please call our specialist UK-based customer services team
                on <strong>{channel.phone}</strong> to see if we can provide you with a quote.
              </p>
              <p>
                We are open {channel.openingHours} closed Bank Holidays.
              </p>
            </li>
          </ul>
        </Modal.Body>
        <Modal.Footer>
          <Button
            bsStyle="primary"
            onClick={this.closeBlockerModal}
          >
            CLOSE
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  private handleRegion = (value: any) => {
    const { dispatch, change } = this.props;
    dispatch(change('region', value.target.value));
    this.setState({
      region: value.target.value,
    });
  }

  private onSelectActivity = (value: any) => {
    const { change, dispatch } = this.props;

    this.setState({
      activitiesValid: true,
    });

    if (value.length === 0) {
        this.setState({
          activitiesValid: false,
        });
    }

    dispatch(change(`activities`, value));
  }

  public render() {
    const {
      i18n,
      submitting,
      tripType,
      handleSubmit,
      valid,
      startDate,
      product,
      renderDefinition,
      submitFailed,
      groupType,
      change,
      channel,
    } = this.props;

    const { activitiesValid } = this.state;
    const hasAdditionalOption = size(product.metadata[`group_type_trip_${tripType}`]) > 4;

    // const regionsList = map(product.metadata.regions, (name, key) => ({
    //   label: name,
    //   value: key,
    // }));

    const maxTripDurationList = map(product.metadata.annual_trip_durations, (name, key) => ({
      label: name,
      value: key,
    }));

    const maxTripDefinition = product.metadata.definitions.max_trip_duration;
    const showMaxTripSelect = size(maxTripDurationList) > 1;
    const showCruiseCover = ['fst-b2c', 'tam-b2c'].includes(channel.key);
    const upperCaseList = ['dia-b2c'];
    const renderTitle = (upperCaseList.indexOf(channel.key) !== -1) ? 'Trip details' : 'TRIP DETAILS';

    const maxDateSingle = () => {
      if (channel.key === 'mpt-b2c') {
        return moment(startDate, 'DD/MM/YYYY').add('365', 'day');
      }

      if (channel.key === 'lsb-b2c') {
        return moment(startDate, 'DD/MM/YYYY').add('18', 'months');
      }

      if (channel.key === 'cps-b2c') {
        return moment(startDate, 'DD/MM/YYYY').add('31', 'day');
      }

      if (channel.key === 'adv-b2c' || channel.key === 'pst-b2c') {
        return moment(startDate, 'DD/MM/YYYY').add('6', 'months');
      }

      if (channel.key === 'eurp-b2c') {
        return moment(startDate, 'DD/MM/YYYY').add('90', 'day');
      }

      return moment(startDate, 'DD/MM/YYYY').add('93', 'day');
    };

    const isMariners = channel.key === 'mpt-b2c';
    const tripDurations = {
      FST: 94,
      CPS: 31,
      DIA: 94,
      MPT: 94,
      LSB: 549,
    };
    const deferredDays = {
      FST: 365,
      DIA: 365,
      MPT: 365,
      LSB: 365,
      CPS: 549,
    };

    let advancedTime = 90;
    let timeType = 'day';
    let annualTime = '366';

    if ((channel.key === 'adv-b2c' || channel.key === 'pst-b2c') && tripType === 'annual') {
      advancedTime = 45;
    } else if (channel.key === 'adv-b2c' || channel.key === 'pst-b2c') {
      advancedTime = 365;
    }

    if (channel.key === 'cps-b2c' && tripType === 'single') {
      advancedTime = 18;
      timeType = 'month';
    } else if (channel.key === 'cps-b2c' && tripType === 'annual') {
      advancedTime = 31;
    }

    if (channel.key === 'eurp-b2c' && tripType === 'annual') {
        advancedTime = 31;
        annualTime = '31';
    }

    const covidMessage = get(product.metadata, 'covid_message.travel_detail_b2c', '');

    const vehicleAge = [
      {value: '00', label: '0 years'},
      {value: '01', label: '1 year old'},
      {value: '02', label: '2 years old'},
      {value: '03', label: '3 years old'},
      {value: '04', label: '4 years old'},
      {value: '05', label: '5 years old'},
      {value: '06', label: '6 years old'},
      {value: '07', label: '7 years old'},
      {value: '08', label: '8 years old'},
      {value: '09', label: '9 years old'},
      {value: '10', label: '10 years old'},
      {value: '11', label: '11 years old'},
      {value: '12', label: '12 years old'},
      {value: '13', label: '13 years old'},
      {value: '14', label: '14 years old'},
      {value: '15', label: 'No more than 15 years old'},
    ];

    const filteredTravellers = () => {
      const productMetadata = product.metadata[`group_type_trip_${tripType}`];
      if (!productMetadata) {
        return null;
      }

      const order = ['individual', 'couple', 'family', 'single_parent_family', 'independent_child'];

      return Object.entries(productMetadata)
          .sort(([keyA], [keyB]) => order.indexOf(keyA) - order.indexOf(keyB))
          .reduce((acc, [key, value]) => {
            acc[key] = value;
            return acc;
          }, {} as Record<string, any>);
    };

    return (
      <Form horizontal={true} onSubmit={handleSubmit} autoComplete="off">
        <div className="steps-container">
          <div className="section-title">
            <h3>{renderTitle}</h3>
          </div>
          <CovidStatement covidMessage={covidMessage}/>
          {size(product.metadata.trip_type) > 0 && (
            <div className="section">
              <FormGroup controlId="trip-type">
                <Row>
                  <Col sm={3}>
                    <ControlLabel>
                      Policy Type:
                      {renderDefinition('trip_type')}
                    </ControlLabel>
                  </Col>
                  <Col sm={9}>
                    <Row className="trip-type-container">
                      {map(product.metadata.trip_type, (name, key) => {
                        return (
                          <Col sm={6} key={key} className="trip-type-btn-container">
                            <Field
                              id={`${key}-trip`}
                              name="tripType"
                              type="radio"
                              value={key}
                              component={FieldFormControl}
                            >
                              <div className={'trip-type-btn'}>
                                {name}
                                <FaCheck/>
                              </div>
                            </Field>
                          </Col>
                        );
                      })}
                    </Row>
                  </Col>
                </Row>
              </FormGroup>
            </div>
          )}
          <div className="section">
            <FormGroup controlId="region">
              <Row>
                <Col sm={3}>
                  <ControlLabel>
                    <div className="region-non-break-label">
                      Destination:
                      {renderDefinition('destinations')}
                    </div>
                  </ControlLabel>
                </Col>
                <Col sm={hasAdditionalOption ? 12 : 9}>
                  <Row className="destination-radio">
                    {map(product.metadata.regions, (name, key) => {
                      const region = name.replace('Caribbean', '\nCaribbean\n');

                      return (
                          <Col xs={12} sm={6} md={hasAdditionalOption ? 2 : 3} key={key}>
                            <Field
                                name="region"
                                type="radio"
                                value={key}
                                component={FieldFormControl}
                                validate={[isRequired]}
                                onClick={this.handleRegion}
                                onBlur={this.handleRegion}
                            >
                              <div>
                                <RegionSelect channel={channel.key} name={key} value={this.state.region}/>
                                <RegionSelected channel={channel.key} name={key}/>
                              </div>
                              {region.replace('United Kingdom', 'UK')}
                            </Field>
                          </Col>
                      );
                    })}
                  </Row>
                </Col>
              </Row>
            </FormGroup>
            <FormGroup>
              <Row>
                <Col sm={12}>
                  {(channel.key === 'dia-b2c') && (
                    <ControlLabel style={{color: '#c22116'}}>
                      Following the outbreak of coronavirus (COVID-19), there will be no cover for cancellation,
                      abandonment, or curtailment claims if the Foreign, Commonwealth and Development Office (FCDO)
                      advises you not to travel, for example where the FCDO advise against all but essential travel to
                      an area affected by Coronavirus, COVID-19, Severe Acute Respiratory Syndrome (SARS-COV-2) or any
                      mutation of Coronavirus, COVID-19 or SARs-COV-2.
                    </ControlLabel>
                  )}
                  {(channel.key === 'pst-b2c') && (
                    <ControlLabel style={{color: '#c22116'}}>
                      Following the outbreak of coronavirus (COVID-19), there will be no cover for claims if the
                      Foreign, Commonwealth and Development Office (FCDO) advises you not to travel, for example
                      where the FCDO advise against all but essential travel to an area affected by Coronavirus,
                      COVID-19, Severe Acute Respiratory Syndrome (SARS-COV-2) or any mutation of Coronavirus,
                      COVID-19 or SARs-COV-2.
                    </ControlLabel>
                  )}
                </Col>
              </Row>
            </FormGroup>

            {showMaxTripSelect && showDestinationDuration(tripType) && (
              <FormGroup controlId="maxTripDuration">
                <MaxTripDuration
                  i18n={i18n}
                  options={maxTripDurationList}
                  definition={maxTripDefinition}
                  renderDefinition={renderDefinition}
                />
              </FormGroup>
            )}

          </div>
          <div className="section">
            <FormGroup controlId="start-date">
              <div className="internal-title">Travel Dates</div>
              <br />
            </FormGroup>
            <FormGroup controlId="start-date">
              <Row>
                <Col componentClass={ControlLabel} sm={3}>
                  Start date:
                  {showDestinations(tripType) ? renderDefinition('travel_dates_single_start_date') :
                    renderDefinition('travel_dates_annual')}
                </Col>
                <Col sm={6}>
                  <div className="alternative-date-picker">
                    <div className="field">
                      <Field
                        name="startDate"
                        id="start-date-text-field"
                        type="masked-date"
                        placeholder="dd/mm/yyyy"
                        component={FieldFormControl}
                      />
                    </div>
                    <div className="icon">
                      <Field
                        name="startDate"
                        minDate={moment()}
                        maxDate={isAnnual(tripType)
                          ? moment().add(annualTime, timeType)
                          : moment().add(advancedTime, timeType)
                        }
                        component={AlternativeDatePicker}
                        validate={isAnnual(tripType) ? [
                          isRequired,
                          isFutureDate,
                          isValidDate,
                          annualLimit(advancedTime),
                        ] : [
                          isRequired,
                          isFutureDate,
                          isValidDate,
                          // singleLimit(deferredDays[product.productCode] || 94),
                        ]}
                      />
                    </div>
                  </div>
                </Col>
              </Row>
            </FormGroup>
            {tripType === 'annual' && channel.key !== 'cps-b2c' && channel.key !== 'adv-b2c' && (
              <Row className="important">
                <strong>IMPORTANT</strong> - Cancellation cover begins on the date you choose
                to start your policy. If you already have a trip booked and you want to be covered
                immediately, you should select today’s date. You can choose to start your policy
                later (up to 31 days from today’s date) but there would not be any cancellation
                cover between now and the start date you choose.
              </Row>
            )}
            {tripType === 'annual' && channel.key === 'adv-b2c' && (
              <Row className="important">
                <strong>IMPORTANT</strong> - Cancellation cover begins on the date you choose
                to start your policy. If you already have a trip booked and you want to be covered
                immediately, you should select today’s date. You can choose to start your policy
                later (up to 45 days from today’s date) but there would not be any cancellation
                cover between now and the start date you choose.
              </Row>
            )}
            {tripType === 'single' && (
              <FormGroup controlId="end-date">
                <Row>
                  <Col componentClass={ControlLabel} sm={3}>
                    Return date: {renderDefinition('travel_dates_single_end_date')}
                  </Col>
                  <Col sm={6}>
                    <div className="alternative-date-picker">
                      <div className="field">
                        <Field
                          name="endDate"
                          type="masked-date"
                          id="end-date-text-field"
                          placeholder="dd/mm/yyyy"
                          component={FieldFormControl}
                        />
                      </div>
                      <div className="icon">
                        <Field
                          name="endDate"
                          minDate={startDate ? moment(startDate, 'DD/MM/YYYY') : moment()}
                          maxDate={startDate ? maxDateSingle() : moment()}
                          component={AlternativeDatePicker}
                          validate={isMariners ? [
                              isRequired,
                              isFutureDate,
                              isValidDate,
                            ] :
                            [
                              isRequired,
                              isFutureDate,
                              isValidDate,
                              // minTripDuration(startDate),
                              // singleMaxTripDuration(startDate, tripDurations[product.productCode] || 365),
                            ]
                          }
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
              </FormGroup>
            )}
          </div>
          {showCruiseCover && (
            <div className="section section--no-padding">
              <CruiseQuestion i18n={i18n} channel={channel}/>
            </div>
          )}
          <div className="section">
            <FormGroup controlId="group-type">
              <Row>
                <Col sm={3}>
                  <ControlLabel>
                    <div className="non-break-label">
                      Travellers Details:{renderDefinition('group_type')}
                    </div>
                  </ControlLabel>
                </Col>
                <Col sm={hasAdditionalOption ? 12 : 9}>
                  <Row className="group-type-radio">
                    {map(filteredTravellers(), (name, key) => {
                      return (
                        <Col xs={6} sm={6} md={hasAdditionalOption ? 2 : 3} key={key}>
                          <Field
                            name="groupType"
                            type="radio"
                            id={key}
                            value={key}
                            component={FieldFormControl}
                            validate={[isRequired]}
                          >
                            <div>
                              <GroupType channel={channel.key} name={key}/>
                              <GroupTypeSelected channel={channel.key} name={key}/>
                            </div>
                            {name}
                          </Field>
                        </Col>
                      );
                    })}
                  </Row>
                </Col>
              </Row>
            </FormGroup>
          </div>
          <FieldArray
            name="travellers"
            i18n={i18n}
            product={product}
            component={Travellers}
            groupType={groupType}
            renderDefinition={renderDefinition}
            change={change}
          />
          <VoucherCode
              renderDefinition={renderDefinition}
              {...this.props}
          />
          {channel.key !== 'pst-b2c' && (
            <div className="section">
              <Row style={{marginBottom: '10px', marginTop: '-5px'}}>
                <Col sm={12}>
                  <Field
                    name="whereDidYouHearAboutUs"
                    type="text"
                    placeholder={'How did you hear about us?'}
                    component={FieldFormControl}
                  />
                </Col>
              </Row>
            </div>
          )}
          {channel.key === 'eurp-b2c' && (
              <div className="section">
                <Row>
                  <Col sm={4}>
                    <ControlLabel>
                      How old is your Vehicle? {this.props.renderDefinition('age_vehicle')}
                    </ControlLabel>
                  </Col>
                  <Col sm={8}>
                    <Field
                        name={'ageVehicle'}
                        type="text"
                        placeholder="Vehicle Age"
                        options={vehicleAge}
                        component={SelectControl}
                        clearable={false}
                        validate={[isRequired]}
                    />
                  </Col>
                </Row>
              </div>
          )}
          {channel.key !== 'dia-b2c' && channel.key !== 'cps-b2c' && channel.key !== 'eurp-b2c' && (
            <div className="section">
              <Row>
                <Field
                    name="activities"
                    type="text"
                    component={ActivitiesSelect}
                    onSelectActivity={this.onSelectActivity}
                    renderDefinition={renderDefinition}
                    productActivities={channel.schemes[0].metadata.activities}
                    validate={[
                      isRequired,
                    ]}
                />
              </Row>
            </div>
          )}
          <div className="section">
            <Row>
              <MarketingOptions/>
            </Row>
          </div>
          <div className="aboutUs">
            {this.renderAboutUs()}
          </div>
          <div className="btn-bar">
            <Button
              id="continue"
              bsStyle="primary"
              className="pull-right"
              onClick={this.checkForErrorBeforeSubmit}
              disabled={submitting || (submitFailed && !valid) || !activitiesValid}
            >
              Continue <FaChevronRight/>
            </Button>
          </div>
        </div>
        {
          this.renderBlockerModal()
        }
      </Form>
    );
  }
}

let selector;
let previousValues;

export default flow([
  reduxForm({
    form: 'quote',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    onChange: (
      values: IPolicyApplication,
      dispatch,
      props: ITripDetailsFormProps,
    ) => {
      if (!previousValues) {
        previousValues = values;
        return;
      }

      let recalculateScore = false;

      if (difference(values.destinations, previousValues.destinations).length > 0) {
        recalculateScore = true;
      }

      if (values.region !== previousValues.region) {
        recalculateScore = true;
      }

      if (recalculateScore) {
        props.actions.quote.recalculateScreening();
      }

      previousValues = values;
    },
  }),
  (component) => {
    selector = formValueSelector('quote');

    return component;
  },
  connect(
    (state: IStore) => {
      const tripType = selector(state, 'tripType');
      const groupType = selector(state, 'groupType');
      const startDate = selector(state, 'startDate');
      const endDate = selector(state, 'endDate');
      const destinationsValue = selector(state, 'destinations');
      const occupationValue = selector(state, 'occupations');
      const industryValue = selector(state, 'industries');
      const region = selector(state, 'region');
      const maxTripDuration = selector(state, 'maxTripDuration');
      const residency = selector(state, 'residency');
      const quotationTypes = selector(state, 'quotationTypes');
      const schemeId = selector(state, 'schemeId');
      const cruiseCover = selector(state, 'cruiseCover');
      const travellers = selector(state, 'travellers');
      const salesChannel = selector(state, 'salesChannel');
      const activities = selector(state, 'activities');
      const ageVehicle = selector(state, 'ageVehicle');

      return {
        cruiseCover,
        tripType,
        quotationTypes,
        residency,
        region,
        maxTripDuration,
        groupType,
        startDate,
        schemeId,
        endDate,
        destinationsValue,
        occupationValue,
        industryValue,
        travellers,
        auth: state.auth,
        channel: state.branding.channel,
        salesChannel,
        activities,
        ageVehicle,
      };
    },
    (dispatch) => ({
      actions: {
        submit: bindActionCreators(submit, dispatch),
        quote: bindActionCreators({...quoteActions}, dispatch),
      },
    }),
  ),
])(TripDetailsForm);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/TripDetails/index.tsx